import React, { useEffect, useRef, useState } from "react";
import api from "../api";
import Shell from "../Shell";

function Banner({ tone = "ok", children, onClose }) {
  // tone: ok | warn | error
  const palette =
    tone === "ok"
      ? { top: "#17944f", bottom: "#0c6aa6" }
      : tone === "warn"
      ? { top: "#d18806", bottom: "#b36f05" }
      : { top: "#d32f2f", bottom: "#a11f1f" };

  return (
    <div
      style={{
        maxWidth: 720,
        margin: "48px auto",
        border: "1px solid #999",
        borderRadius: 18,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div style={{ height: 18, background: palette.top }} />
      <div style={{ padding: "40px 24px", textAlign: "center", fontSize: 28 }}>
        {children}
        <div style={{ marginTop: 8, fontSize: 14, opacity: 0.7 }}>
          Lokar sjálfkrafa eftir 6 sekúndur
        </div>
      </div>
      <div style={{ height: 18, background: palette.bottom }} />
      <div style={{ textAlign: "center", padding: 20 }}>
        <button className="btn" onClick={onClose}>
          Skrá næsta
        </button>
      </div>
    </div>
  );
}

export default function HouseAttendance() {
  const [username, setUsername] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null); // { tone: "ok" | "warn" | "error", message: string }
  const inputRef = useRef(null);
  const bannerTimer = useRef(null);

  // Close banner → reset and focus input
  const handleBannerClose = () => {
    setResult(null);
    requestAnimationFrame(() => inputRef.current?.focus());
  };

  // Auto-dismiss after 6 seconds whenever a result appears
  useEffect(() => {
    if (!result) return;
    if (bannerTimer.current) clearTimeout(bannerTimer.current);
    bannerTimer.current = setTimeout(() => handleBannerClose(), 6000);
    return () => {
      if (bannerTimer.current) clearTimeout(bannerTimer.current);
    };
  }, [result]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim()) return;

    setSubmitting(true);
    setResult(null);
    try {
      const { data } = await api.post("/api/attendance/house/mark/", {
        username: username.trim(),
      });
      if (data.ok) {
        setResult({ tone: "ok", message: data.message || "Mæting skráð!" });
      } else {
        setResult({
          tone: "warn",
          message: data.message || "Ekki tókst að skrá.",
        });
      }
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        "Mæting ekki skráð – Notandanafn finnst ekki. Vinsamlegast reyndu aftur!";
      setResult({ tone: "error", message: msg });
    } finally {
      setSubmitting(false);
      setUsername("");
    }
  };

  return (
    <Shell title="Skrá mætingu í hús" rightMenu brandClickable={false} brandTitle="Hugarafl">
      {!result ? (
        <div
          style={{
            maxWidth: 720,
            margin: "64px auto",
            border: "1px solid #999",
            borderRadius: 28,
            padding: 32,
          }}
        >
          <div style={{ textAlign: "center", fontSize: 36, marginBottom: 28 }}>
            Skrá mætingu í hús
          </div>

          <form
            onSubmit={onSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 16,
            }}
          >
            <label
              htmlFor="username"
              style={{ alignSelf: "center", fontSize: 18 }}
            >
              Notandanafn
            </label>
            <input
              id="username"
              ref={inputRef}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Sláðu inn notandanafn"
              style={{ width: 360 }}
              disabled={submitting}
            />
            <button className="btn" disabled={submitting || !username.trim()}>
              {submitting ? "Skrái…" : "Staðfesta"}
            </button>
          </form>
        </div>
      ) : (
        <Banner tone={result.tone} onClose={handleBannerClose}>
          {result.message}
        </Banner>
      )}
    </Shell>
  );
}